import styled from 'styled-components';

export const StyledTableCell = styled.div`
  display: flex;
  align-items: center;
  margin: ${({ theme: { space } }) => `${space[8]} ${space[4]}`};
`;
